import { render, staticRenderFns } from "./edit-quiz-single-question.html?vue&type=template&id=062b0861&scoped=true&external"
import script from "./edit-quiz-single-question.vue?vue&type=script&lang=js"
export * from "./edit-quiz-single-question.vue?vue&type=script&lang=js"
import style0 from "./edit-quiz-single-question.css?vue&type=style&index=0&id=062b0861&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b0861",
  null
  
)

export default component.exports